import React from 'react';

const BottomNavigation = ({
  activeTab,
  setActiveTab,
  darkMode,
  cart,
  setSelectedBrand,
  setSelectedModel,
  setSelectedModification,
  setSelectedRoofType,
  setShowResults
}) => {
  return (
    <nav className={`fixed bottom-0 left-0 right-0 h-16 flex justify-around items-center shadow-lg ${darkMode ? 'bg-gray-800 text-gray-300' : 'bg-white'
      }`} aria-label="Основная навигация">
      <button
        onClick={() => {
          // Переключаемся на вкладку selector, но не сбрасываем значения
          setActiveTab('selector');
        }}
        className={`flex flex-col items-center justify-center w-1/6 ${activeTab === 'selector' ? 'text-blue-500' : ''
          }`}
        aria-current={activeTab === 'selector' ? 'page' : undefined}
      >
        <i className="fas fa-car text-lg" aria-hidden="true"></i>
        <span className="text-xs mt-1">Подбор</span>
      </button>
      <button
        onClick={() => setActiveTab('favorites')}
        className={`flex flex-col items-center justify-center w-1/6 ${activeTab === 'favorites' ? 'text-blue-500' : ''
          }`}
        aria-current={activeTab === 'favorites' ? 'page' : undefined}
      >
        <i className="fas fa-heart text-lg" aria-hidden="true"></i>
        <span className="text-xs mt-1">Избранное</span>
      </button>
      <button
        onClick={() => setActiveTab('faq')}
        className={`flex flex-col items-center justify-center w-1/6 ${activeTab === 'faq' ? 'text-blue-500' : ''
          }`}
        aria-current={activeTab === 'faq' ? 'page' : undefined}
      >
        <i className="fas fa-question-circle text-lg" aria-hidden="true"></i>
        <span className="text-xs mt-1">FAQ</span>
      </button>
      <button
        onClick={() => setActiveTab('blog')}
        className={`flex flex-col items-center justify-center w-1/6 ${activeTab === 'blog' ? 'text-blue-500' : ''
          }`}
        aria-current={activeTab === 'blog' ? 'page' : undefined}
      >
        <i className="fas fa-newspaper text-lg" aria-hidden="true"></i>
        <span className="text-xs mt-1">Блог</span>
      </button>
      <button
        onClick={() => setActiveTab('contacts')}
        className={`flex flex-col items-center justify-center w-1/6 ${activeTab === 'contacts' ? 'text-blue-500' : ''
          }`}
        aria-current={activeTab === 'contacts' ? 'page' : undefined}
      >
        <i className="fas fa-address-book text-lg" aria-hidden="true"></i>
        <span className="text-xs mt-1">Контакты</span>
      </button>
      <button
        onClick={() => setActiveTab('cart')}
        className={`flex flex-col items-center justify-center w-1/6 ${activeTab === 'cart' ? 'text-blue-500' : ''
          }`}
        aria-current={activeTab === 'cart' ? 'page' : undefined}
      >
        <div className="relative">
          <i className="fas fa-shopping-cart text-lg" aria-hidden="true"></i>
          {cart.length > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center" aria-label={`${cart.length} товаров в корзине`}>
              {cart.length}
            </span>
          )}
        </div>
        <span className="text-xs mt-1">Корзина</span>
      </button>
    </nav>
  );
};

export default BottomNavigation;